import React, { Component } from "react";
import { connect } from "react-redux";
class PublicContainer extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        const attrs = {};
        if (this.props.isActiveModal) {
            attrs["aria-hidden"] = true;
        }
        return (<div {...attrs}>
				{this.props.children}
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => {
    return {
        isActiveModal: state.ui.isActiveModal
    };
};
/* Create and export container component that wraps Dashboard for property binding */
export default connect(mapStateToProps)(PublicContainer);



// WEBPACK FOOTER //
// ./src/assets/scripts/PublicContainer.tsx